<template>
    <div class="cost-management">
        <!-- 헤더 -->
        <div class="content-header">
            <h3>
                <i class="fas fa-file-invoice-dollar"></i>
                요금제 관리
            </h3>
            <div class="header-content-group">
                <!-- 검색 바 -->
                <div class="search-bar-header">
                    <div class="form-field-inline">
                        <select v-model="filterSupplier" class="form-select-header" @change="handleSearch">
                            <option value="">공급자 전체</option>
                            <option
                                v-for="supplier in supplierList"
                                :key="supplier.supplierIdx"
                                :value="supplier.supplierIdx"
                            >
                                {{ supplier.supplierName }}
                            </option>
                        </select>
                    </div>

                    <div class="form-field-inline">
                        <select v-model="filterType" class="form-select-header" @change="handleSearch">
                            <option value="">요금제 구분 전체</option>
                            <option value="Fixed">고정</option>
                            <option value="Contract">계약기반</option>
                            <option value="Demand">수요기반</option>
                            <option value="Progressive">누진제</option>
                            <option value="PeakLinked">피크연동제</option>
                            <option value="None">없음</option>
                        </select>
                    </div>

                    <!-- <div class="form-field-inline">
                        <div class="search-input-group-header">
                            <i class="fas fa-search"></i>
                            <input
                                type="text"
                                v-model="searchKeyword"
                                placeholder="요금표명 입력"
                                class="search-input-header"
                                @keyup.enter="handleSearch"
                            />
                        </div>
                    </div> -->

                    <!-- <div class="form-field-inline">
                        <button class="btn-search-header" @click="handleSearch">
                            <i class="fas fa-search"></i>
                            검색
                        </button>
                    </div> -->
                </div>

                <div class="header-actions-group">
                    <button
                        class="btn-action btn-danger"
                        @click="handleDeleteSelected"
                        :disabled="selectedCosts.length === 0"
                    >
                        <i class="fas fa-trash-alt"></i>
                        삭제 ({{ selectedCosts.length }})
                    </button>
                    <button
                        class="btn-action btn-secondary"
                        @click="handleExport"
                        :disabled="selectedCosts.length === 0"
                    >
                        <i class="fas fa-file-export"></i>
                        Export ({{ selectedCosts.length }})
                    </button>
                    <button class="btn-action btn-secondary" @click="handleImport">
                        <i class="fas fa-file-import"></i>
                        Import
                    </button>
                    <!-- <button class="btn-action btn-excel" @click="exportToExcel">
                    <i class="fas fa-file-excel"></i>
                    Excel
                </button> -->
                    <button class="btn-action btn-primary" @click="openCreateForm">
                        <i class="fas fa-plus"></i>
                        신규 등록
                    </button>
                </div>
            </div>
        </div>

        <!-- 요금제 목록 테이블 -->
        <div class="data-table-container">
            <table class="settings-data-table">
                <thead>
                    <tr>
                        <th style="width: 40px">
                            <input type="checkbox" :checked="allSelected" @change="toggleSelectAll" @click.stop />
                        </th>
                        <th>요금표명</th>
                        <th>공급자</th>
                        <th>요금제 구분</th>
                        <th class="text-right">기본요금</th>
                        <th class="text-center">작업</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="cost in filteredCosts"
                        :key="cost.costIdx"
                        class="clickable-row"
                        @click="openViewForm(cost)"
                    >
                        <td @click.stop>
                            <input type="checkbox" :value="cost.costIdx" v-model="selectedCosts" @click.stop />
                        </td>
                        <td>
                            {{ cost.costName }}
                        </td>
                        <td>
                            {{ cost.supplier ? cost.supplier.supplierName : "-" }}
                        </td>
                        <td>
                            {{ getChargeTypeName(cost.baseFeeCalcType) }}
                        </td>
                        <td class="text-right">{{ formatNumber(cost.baseFeeValue) }}원</td>
                        <td class="text-center" @click.stop>
                            <button class="btn-edit" @click="openEditForm(cost)">
                                <i class="fas fa-edit"></i>
                                요금제 설정
                            </button>
                            <button
                                v-if="cost.hasFlatCost !== 1"
                                class="btn-detail"
                                @click="openDetailManagement(cost)"
                            >
                                <i class="fas fa-calculator"></i>
                                단위요금 설정
                            </button>
                            <button class="btn-delete" @click="handleDelete(cost)">
                                <i class="fas fa-trash-alt"></i>
                                삭제
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 요금제 등록/수정/상세 폼 (슬라이드 패널) -->
        <SettingsSidePanel :show="showForm" :title="formTitle" size="default" @close="closeForm">
            <!-- 기본 정보 -->
            <div class="section-title">기본 정보</div>

            <div class="form-row">
                <div class="form-group form-group--full">
                    <label> 요금표명 <span v-if="!isViewMode" class="required">*</span> </label>
                    <input
                        type="text"
                        v-model="form.costName"
                        placeholder="요금표명을 입력하세요"
                        class="form-input"
                        :disabled="isViewMode"
                    />
                </div>

                <div class="form-group">
                    <label> 공급자 <span v-if="!isViewMode" class="required">*</span> </label>
                    <select v-model="form.supplierIdx" class="form-select" :disabled="isViewMode">
                        <option :value="null">공급자 선택</option>
                        <option
                            v-for="supplier in supplierList"
                            :key="supplier.supplierIdx"
                            :value="supplier.supplierIdx"
                        >
                            {{ supplier.supplierName }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label> 요금 단위 </label>
                    <select v-model="form.billingUnit" class="form-select" :disabled="isViewMode">
                        <option :value="null">요금 단위 선택</option>
                        <option v-for="unit in unitList" :key="unit.codeItem" :value="unit.codeItem">
                            {{ unit.codeName }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group" @click="toggleStartDatePicker" style="cursor: pointer">
                    <label> 적용 시작일 <span v-if="!isViewMode" class="required">*</span> </label>
                    <div class="date-picker-container" v-click-outside="closeStartDatePicker">
                        <div class="date-display" :class="{ disabled: isViewMode }">
                            <span>{{ startDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showStartDatePicker }]"></i>
                        </div>

                        <!-- 드롭다운 -->
                        <div v-if="showStartDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeStartYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ startDateYear }}</span>
                                <button @click.stop="changeStartYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === startDateMonth }]"
                                    @click.stop="selectStartMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="startDateMonth" class="day-grid">
                                <button
                                    v-for="day in startDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === startDateDay }]"
                                    @click.stop="selectStartDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group" @click="toggleEndDatePicker" style="cursor: pointer">
                    <label> 적용 종료일 </label>
                    <div class="date-picker-container" v-click-outside="closeEndDatePicker">
                        <div class="date-display" :class="{ disabled: isViewMode }">
                            <span>{{ endDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showEndDatePicker }]"></i>
                        </div>

                        <!-- 드롭다운 -->
                        <div v-if="showEndDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeEndYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ endDateYear }}</span>
                                <button @click.stop="changeEndYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === endDateMonth }]"
                                    @click.stop="selectEndMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="endDateMonth" class="day-grid">
                                <button
                                    v-for="day in endDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === endDateDay }]"
                                    @click.stop="selectEndDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                            <!-- 미지정 버튼 -->
                            <div class="clear-date-section">
                                <button class="btn-clear-date" @click.stop="clearEndDate">
                                    <i class="fas fa-times-circle"></i>
                                    미지정
                                </button>
                            </div>
                        </div>
                    </div>
                    <small class="help-text">종료일을 지정하지 않으면 계속 적용됩니다.</small>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label> 기본요금 계산 방식 <span v-if="!isViewMode" class="required">*</span> </label>
                    <select v-model="form.baseFeeCalcType" class="form-select" :disabled="isViewMode">
                        <option :value="null">계산 방식 선택</option>
                        <option value="Fixed">고정 (Fixed)</option>
                        <option value="Contract">계약기반 (Contract)</option>
                        <option value="Demand">수요기반 (Demand)</option>
                        <option value="PeakLinked">피크연동제 (PeakLinked)</option>
                        <option value="None">없음 (None)</option>
                    </select>
                </div>

                <div v-if="shouldShowBaseFeeValue" class="form-group">
                    <label>
                        기본요금 값
                        <span v-if="isBaseFeeValueRequired && !isViewMode" class="required">*</span>
                    </label>
                    <div class="input-with-unit">
                        <input
                            type="number"
                            v-model.number="form.baseFeeValue"
                            placeholder="0"
                            class="form-input"
                            :disabled="isViewMode"
                        />
                        <span class="unit">원</span>
                    </div>
                </div>
                <div class="form-group">
                    <label> 부가세율 </label>
                    <div class="input-with-unit">
                        <input
                            type="number"
                            v-model.number="form.vatRate"
                            placeholder="0.1"
                            step="0.01"
                            min="0"
                            max="1"
                            class="form-input"
                            :disabled="isViewMode || form.hasFlatCost === 1"
                        />
                        <span class="unit-desc">(0.1 = 10%)</span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>사용 요금 계산 방식<span v-if="!isViewMode" class="required">*</span> </label>
                <div class="checkbox-group">
                    <!-- 누진제: 배타적 선택 -->
                    <div class="checkbox-row">
                        <label
                            class="checkbox-label exclusive"
                            :class="{ active: form.hasProgressive === 1, disabled: form.hasFlatCost === 1 }"
                        >
                            <input
                                type="checkbox"
                                v-model="form.hasProgressive"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isViewMode || form.hasFlatCost === 1"
                                @change="handleProgressiveChange"
                            />
                            <span style="margin-left: 5px">누진제 (사용량 구간별)</span>
                        </label>
                        <label
                            class="checkbox-label"
                            :class="{
                                active: form.hasFlatCost === 1,
                                disabled: form.hasProgressive === 1,
                            }"
                        >
                            <input
                                type="checkbox"
                                v-model="form.hasFlatCost"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isViewMode || form.hasProgressive === 1"
                                @change="handlePlatCostChange"
                            />
                            <span style="margin-left: 5px">단일 요금제</span>
                        </label>
                    </div>

                    <!-- 나머지 3개: 누진제가 0일때만 선택 가능 -->
                    <div class="checkbox-row">
                        <label
                            class="checkbox-label"
                            :class="{
                                disabled: form.hasProgressive === 1 || form.hasFlatCost === 1,
                                active: form.hasSeason === 1,
                            }"
                        >
                            <input
                                type="checkbox"
                                v-model="form.hasSeason"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isViewMode || form.hasProgressive === 1 || form.hasFlatCost === 1"
                            />
                            <span style="margin-left: 5px">계절별 (봄가을/하계/동계)</span>
                        </label>

                        <label
                            class="checkbox-label"
                            :class="{
                                disabled: form.hasProgressive === 1 || form.hasFlatCost === 1,
                                active: form.hasTimeSlot === 1,
                            }"
                        >
                            <input
                                type="checkbox"
                                v-model="form.hasTimeSlot"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isViewMode || form.hasProgressive === 1 || form.hasFlatCost === 1"
                            />
                            <span style="margin-left: 5px">시간대별 (경부하/중부하/최대부하)</span>
                        </label>

                        <label
                            class="checkbox-label"
                            :class="{
                                disabled: form.hasProgressive === 1 || form.hasFlatCost === 1,
                                active: form.hasDayType === 1,
                            }"
                        >
                            <input
                                type="checkbox"
                                v-model="form.hasDayType"
                                :true-value="1"
                                :false-value="0"
                                :disabled="isViewMode || form.hasProgressive === 1 || form.hasFlatCost === 1"
                            />
                            <span style="margin-left: 5px">요일별 (주중/주말/공휴일)</span>
                        </label>
                    </div>
                </div>

                <!-- 선택된 타입 안내 -->
                <div class="structure-info" v-if="costStructureType && !isViewMode">
                    <span class="info-badge" :class="costStructureType.level">
                        {{ costStructureType.name }}
                    </span>
                    <span class="info-desc">{{ costStructureType.description }}</span>
                </div>
            </div>

            <div v-if="shouldShowFlatCostFee" class="form-row">
                <div class="form-group">
                    <label>
                        단일 요금제 단위요금
                        <span v-if="isFlatCostFeeRequired && !isViewMode" class="required">*</span>
                    </label>
                    <div class="input-with-unit">
                        <input
                            type="number"
                            v-model.number="form.flatCostFee"
                            placeholder="0"
                            class="form-input"
                            :disabled="isViewMode"
                        />
                        <span class="unit-desc">(원)</span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>비고</label>
                <textarea
                    v-model="form.remarks"
                    placeholder="텍스트 입력"
                    rows="3"
                    class="form-textarea"
                    :disabled="isViewMode"
                ></textarea>
            </div>

            <!-- 단위요금 정보 (상세보기 모드일 때만 표시) -->
            <div v-if="isViewMode && form.hasFlatCost !== 1" class="cost-detail-section">
                <div class="section-title">단위요금 정보</div>

                <!-- Type A: 누진제 -->
                <div v-if="viewStructureType === 'progressive'" class="detail-table-container">
                    <table class="detail-table">
                        <thead>
                            <tr>
                                <th>구간</th>
                                <th>사용량 범위</th>
                                <th class="text-right">단위요금 (원/kWh)</th>
                                <th class="text-right">기본요금 (원)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, idx) in viewCostDetails" :key="idx">
                                <td>{{ idx + 1 }}구간</td>
                                <td>{{ formatUsageRange(detail) }}</td>
                                <td class="text-right">{{ formatNumber(detail.unitPrice, 2) }}</td>
                                <td class="text-right">{{ formatNumber(detail.baseFeeValue, 0) }}</td>
                            </tr>
                            <tr v-if="viewCostDetails.length === 0">
                                <td colspan="4" class="empty-detail">
                                    <i class="fas fa-exclamation-circle"></i>
                                    <p>등록된 단위요금 정보가 없습니다.</p>
                                    <p class="help-text">목록의 [단위요금 설정] 버튼을 통해 단위요금을 등록하세요.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Type B: 1차원 -->
                <div v-else-if="viewStructureType === 'single'" class="detail-table-container">
                    <table class="detail-table">
                        <thead>
                            <tr>
                                <th>
                                    {{
                                        singleDimensionType === "season"
                                            ? "계절"
                                            : singleDimensionType === "timeSlot"
                                              ? "시간대"
                                              : "요일 구분"
                                    }}
                                </th>
                                <th class="text-right">단위요금 (원/kWh)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="detail in viewCostDetails"
                                :key="detail.seasonCode || detail.timeSlotCode || detail.dayType"
                            >
                                <td>
                                    <span class="badge-dimension">
                                        {{
                                            singleDimensionType === "season"
                                                ? getSeasonLabel(detail.seasonCode)
                                                : singleDimensionType === "timeSlot"
                                                  ? getTimeSlotLabel(detail.timeSlotCode)
                                                  : getDayTypeLabel(detail.dayType)
                                        }}
                                    </span>
                                </td>
                                <td class="text-right">{{ formatNumber(detail.unitPrice, 2) }}</td>
                            </tr>
                            <tr v-if="viewCostDetails.length === 0">
                                <td colspan="2" class="empty-detail">
                                    <i class="fas fa-exclamation-circle"></i>
                                    <p>등록된 단위요금 정보가 없습니다.</p>
                                    <p class="help-text">목록의 [단위요금 설정] 버튼을 통해 단위요금을 등록하세요.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Type C: 2차원 -->
                <div v-else-if="viewStructureType === 'dual'" class="detail-table-container">
                    <!-- 계절 × 시간대 -->
                    <table
                        v-if="dualDimensionTypes.includes('season') && dualDimensionTypes.includes('timeSlot')"
                        class="detail-table matrix-table"
                    >
                        <thead>
                            <tr>
                                <th class="row-header-cell">계절 \ 시간대</th>
                                <th v-for="timeSlot in timeSlotOptions" :key="timeSlot.code" class="text-center">
                                    {{ timeSlot.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="season in seasonOptions" :key="season.code">
                                <td class="row-header">{{ season.label }}</td>
                                <td v-for="timeSlot in timeSlotOptions" :key="timeSlot.code" class="text-right">
                                    {{ getDetailPrice(season.code, timeSlot.code, undefined) }}
                                </td>
                            </tr>
                            <tr v-if="viewCostDetails.length === 0">
                                <td colspan="4" class="empty-detail">
                                    <i class="fas fa-exclamation-circle"></i>
                                    <p>등록된 단위요금 정보가 없습니다.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- 계절 × 요일 -->
                    <table
                        v-else-if="dualDimensionTypes.includes('season') && dualDimensionTypes.includes('dayType')"
                        class="detail-table matrix-table"
                    >
                        <thead>
                            <tr>
                                <th class="row-header-cell">계절 \ 요일</th>
                                <th v-for="dayType in dayTypeOptions" :key="dayType.code" class="text-center">
                                    {{ dayType.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="season in seasonOptions" :key="season.code">
                                <td class="row-header">{{ season.label }}</td>
                                <td v-for="dayType in dayTypeOptions" :key="dayType.code" class="text-right">
                                    {{ getDetailPrice(season.code, undefined, dayType.code) }}
                                </td>
                            </tr>
                            <tr v-if="viewCostDetails.length === 0">
                                <td colspan="4" class="empty-detail">
                                    <i class="fas fa-exclamation-circle"></i>
                                    <p>등록된 단위요금 정보가 없습니다.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- 시간대 × 요일 -->
                    <table
                        v-else-if="dualDimensionTypes.includes('timeSlot') && dualDimensionTypes.includes('dayType')"
                        class="detail-table matrix-table"
                    >
                        <thead>
                            <tr>
                                <th class="row-header-cell">시간대 \ 요일</th>
                                <th v-for="dayType in dayTypeOptions" :key="dayType.code" class="text-center">
                                    {{ dayType.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="timeSlot in timeSlotOptions" :key="timeSlot.code">
                                <td class="row-header">{{ timeSlot.label }}</td>
                                <td v-for="dayType in dayTypeOptions" :key="dayType.code" class="text-right">
                                    {{ getDetailPrice(undefined, timeSlot.code, dayType.code) }}
                                </td>
                            </tr>
                            <tr v-if="viewCostDetails.length === 0">
                                <td colspan="4" class="empty-detail">
                                    <i class="fas fa-exclamation-circle"></i>
                                    <p>등록된 단위요금 정보가 없습니다.</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Type D: 3차원 -->
                <div v-else-if="viewStructureType === 'triple'" class="triple-dimension-view">
                    <!-- 계절별 탭 -->
                    <div class="season-tabs">
                        <button
                            v-for="season in seasonOptions"
                            :key="season.code"
                            :class="['season-tab', { active: selectedViewSeason === season.code }]"
                            @click="selectedViewSeason = season.code"
                        >
                            {{ season.label }}
                        </button>
                    </div>

                    <!-- 일 유형 탭 (주중/주말/공휴일) -->
                    <div class="season-tabs day-type-tabs">
                        <button
                            v-for="day in viewDayTypeTabs"
                            :key="day.code"
                            :class="['season-tab', { active: selectedViewDayType === day.code }]"
                            @click="selectedViewDayType = day.code"
                        >
                            {{ day.label }}
                        </button>
                    </div>

                    <!-- 선택된 계절·일 유형의 시간대 그리드 -->
                    <div class="hour-grid-container">
                        <div class="day-type-grid">
                            <table class="hour-grid-table">
                                <thead>
                                    <tr>
                                        <th style="width: 120px">시간</th>
                                        <th style="width: 100px">부하타입</th>
                                        <th style="width: 120px">단위요금 (원/kWh)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="hour in 24" :key="selectedViewDayType + '-' + hour">
                                        <template
                                            v-if="
                                                isViewTimeSlotStart(selectedViewSeason, selectedViewDayType, hour - 1)
                                            "
                                        >
                                            <td
                                                class="hour-cell"
                                                :rowspan="
                                                    getViewTimeSlotRowspan(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                "
                                            >
                                                {{ hour - 1 }}시 ~
                                                {{
                                                    getViewTimeSlotEndHour(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                }}시
                                            </td>
                                            <td
                                                class="load-type-cell"
                                                :class="
                                                    getViewLoadTypeClass(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                "
                                                :rowspan="
                                                    getViewTimeSlotRowspan(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                "
                                            >
                                                {{
                                                    getViewLoadTypeName(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                }}
                                            </td>
                                            <td
                                                class="price-cell"
                                                :rowspan="
                                                    getViewTimeSlotRowspan(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                "
                                            >
                                                {{
                                                    getViewTimeSlotPrice(
                                                        selectedViewSeason,
                                                        selectedViewDayType,
                                                        hour - 1,
                                                    )
                                                }}
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- 데이터 없음 -->
                    <div v-if="viewCostDetails.length === 0" class="empty-detail" style="margin-top: 16px">
                        <i class="fas fa-exclamation-circle"></i>
                        <p>등록된 단위요금 정보가 없습니다.</p>
                        <p class="help-text">목록의 [단위요금 설정] 버튼을 통해 단위요금을 등록하세요.</p>
                    </div>
                </div>

                <!-- 데이터 없음 또는 구조 미설정 -->
                <div v-else class="empty-detail">
                    <i class="fas fa-exclamation-circle"></i>
                    <p>등록된 단위요금 정보가 없습니다.</p>
                    <p class="help-text">목록의 [단위요금 설정] 버튼을 통해 단위요금을 등록하세요.</p>
                </div>
            </div>

            <!-- 상세 정보 (상세보기 모드일 때만 표시) -->
            <div v-if="isViewMode" class="detail-info">
                <div class="info-row">
                    <span class="info-label">등록일시:</span>
                    <span class="info-value">{{ form.regDate || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">등록자:</span>
                    <span class="info-value">{{ form.regWorker || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">수정일시:</span>
                    <span class="info-value">{{ form.modDate || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">수정자:</span>
                    <span class="info-value">{{ form.modWorker || "-" }}</span>
                </div>
            </div>

            <!-- 단위요금 정보 안내 (신규 등록/수정 모드일 때만 표시) -->
            <div v-if="!isViewMode" class="cost-detail-info">
                <div class="info-box">
                    <i class="fas fa-info-circle"></i>
                    <div class="info-text">
                        <strong>단위요금 정보 관리</strong>
                        <p>
                            단위요금 정보는 요금제 등록 후 목록의 [단위요금 설정] 버튼을 통해 등록 및 수정할 수
                            있습니다.
                        </p>
                    </div>
                </div>
            </div>
            <template #footer>
                <button class="btn-cancel" @click="closeForm">
                    <i class="fas fa-times"></i>
                    {{ isViewMode ? "닫기" : "취소" }}
                </button>
                <button v-if="!isViewMode" class="btn-save" @click="handleSave">
                    <i class="fas fa-save"></i>
                    저장
                </button>
            </template>
        </SettingsSidePanel>

        <!-- Import 결과 모달 -->
        <div v-if="showImportResult" class="modal-overlay" @click="closeImportResult">
            <div class="modal-content import-result-modal" @click.stop>
                <div class="modal-header">
                    <h4>Import 결과</h4>
                    <button class="btn-close-modal" @click="closeImportResult">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="importResult">
                        <h5>공급자 정보</h5>
                        <div class="import-result-section">
                            <div v-if="importResult.suppliers.created.length > 0" class="result-item success">
                                <i class="fas fa-check-circle"></i>
                                <span>생성: {{ importResult.suppliers.created.length }}개</span>
                                <ul>
                                    <li v-for="code in importResult.suppliers.created" :key="code">{{ code }}</li>
                                </ul>
                            </div>
                            <div v-if="importResult.suppliers.updated.length > 0" class="result-item info">
                                <i class="fas fa-sync-alt"></i>
                                <span>업데이트: {{ importResult.suppliers.updated.length }}개</span>
                                <ul>
                                    <li v-for="code in importResult.suppliers.updated" :key="code">{{ code }}</li>
                                </ul>
                            </div>
                            <div v-if="importResult.suppliers.skipped.length > 0" class="result-item warning">
                                <i class="fas fa-exclamation-triangle"></i>
                                <span>건너뜀: {{ importResult.suppliers.skipped.length }}개</span>
                                <ul>
                                    <li v-for="(item, idx) in importResult.suppliers.skipped" :key="idx">
                                        {{ item.supplier?.supplierCode || "Unknown" }} - {{ item.reason }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <h5>요금제 정보</h5>
                        <div class="import-result-section">
                            <div v-if="importResult.costs.created.length > 0" class="result-item success">
                                <i class="fas fa-check-circle"></i>
                                <span>생성: {{ importResult.costs.created.length }}개</span>
                                <ul>
                                    <li v-for="(item, idx) in importResult.costs.created" :key="idx">
                                        {{ item.costName }} ({{ item.supplierCode }})
                                    </li>
                                </ul>
                            </div>
                            <div v-if="importResult.costs.updated.length > 0" class="result-item info">
                                <i class="fas fa-sync-alt"></i>
                                <span>업데이트: {{ importResult.costs.updated.length }}개</span>
                                <ul>
                                    <li v-for="(item, idx) in importResult.costs.updated" :key="idx">
                                        {{ item.costName }} ({{ item.supplierCode }})
                                    </li>
                                </ul>
                            </div>
                            <div v-if="importResult.costs.skipped.length > 0" class="result-item warning">
                                <i class="fas fa-exclamation-triangle"></i>
                                <span>건너뜀: {{ importResult.costs.skipped.length }}개</span>
                                <ul>
                                    <li v-for="(item, idx) in importResult.costs.skipped" :key="idx">
                                        {{ item.cost?.costName || "Unknown" }} - {{ item.reason }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="importResult.costs.errors.length > 0" class="result-item error">
                                <i class="fas fa-times-circle"></i>
                                <span>오류: {{ importResult.costs.errors.length }}개</span>
                                <ul>
                                    <li v-for="(item, idx) in importResult.costs.errors" :key="idx">
                                        {{ item.cost?.costName || "Unknown" }} - {{ item.reason }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn-primary" @click="closeImportResult">확인</button>
                </div>
            </div>
        </div>

        <!-- 단위요금 설정 패널 -->
        <CostDetailManagement
            v-if="showDetailManagement && selectedCostIdx"
            :show="showDetailManagement"
            :costIdx="selectedCostIdx"
            :costInfo="selectedCostInfo"
            :costData="selectedCostData"
            @close="closeDetailManagement"
            @saved="handleDetailSaved"
        />
    </div>
</template>

<script>
import SettingsSidePanel from "../settings/SettingsSidePanel.vue";
import backEndApi from "@src/api/backEndApi.js";
import * as XLSX from "xlsx";
import CostDetailManagement from "./CostDetailManagement.vue";
import { shouldShowField, isFieldRequired } from "@/utils/fieldDisplayHelper";

export default {
    name: "CostManagement",
    components: {
        SettingsSidePanel,
        CostDetailManagement,
    },
    directives: {
        clickOutside: {
            bind(el, binding) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event);
                    }
                };
                document.body.addEventListener("click", el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener("click", el.clickOutsideEvent);
            },
        },
    },
    data() {
        return {
            searchKeyword: "",
            filterSupplier: "",
            filterType: "",
            selectedCosts: [], // Export용 선택된 요금제 목록
            importFileInput: null, // Import 파일 input 참조
            showImportResult: false, // Import 결과 모달 표시 여부
            importResult: null, // Import 결과 데이터
            showForm: false,
            isViewMode: false,
            isEditMode: false,
            editingCost: null,
            // 시작일 날짜 선택기
            showStartDatePicker: false,
            startDateYear: new Date().getFullYear(),
            startDateMonth: new Date().getMonth() + 1,
            startDateDay: new Date().getDate(),
            // 종료일 날짜 선택기
            showEndDatePicker: false,
            endDateYear: new Date().getFullYear(),
            endDateMonth: new Date().getMonth() + 1,
            endDateDay: new Date().getDate(),
            form: {
                costName: null,
                supplierIdx: null,
                applyStartDt: null,
                applyEndDt: null,
                baseFeeCalcType: null,
                billingUnit: null,
                baseFeeValue: 0,
                flatCostFee: null,
                hasFlatCost: 0,
                hasProgressive: 0,
                hasSeason: 0,
                hasTimeSlot: 0,
                hasDayType: 0,
                vatRate: 0.1,
                fuelAdjQuarter: null,
                enabled: "Y",
                remarks: null,
            },
            costs: [],
            supplierList: [],
            costDetail: null,
            viewCostDetails: [], // 상세보기용 단위요금 정보
            showDetailManagement: false,
            selectedCostIdx: null,
            selectedCostInfo: {},
            selectedCostData: null, // 전체 요금제 데이터 (API 중복 호출 방지용)
            originalStructure: null, // 수정 전 단위요금 구조 (변경 감지용)
            selectedViewSeason: "MID", // 3차원 상세보기용 선택된 계절
            selectedViewDayType: "WEEKDAY", // 3차원 상세보기용 선택된 일 유형
            viewDayTypeTabs: [
                { code: "WEEKDAY", label: "주중" },
                { code: "WEEKEND", label: "주말" },
                { code: "HOLIDAY", label: "공휴일" },
            ],
            // 코드 매핑 (상세보기용)
            seasonOptions: [
                { code: "MID", label: "봄/가을" },
                { code: "SUMMER", label: "하계" },
                { code: "WINTER", label: "동계" },
            ],
            timeSlotOptions: [
                { code: "LOW", label: "경부하" },
                { code: "MID", label: "중부하" },
                { code: "PEAK", label: "최대부하" },
            ],
            dayTypeOptions: [
                { code: "WEEKDAY", label: "주중" },
                { code: "WEEKEND", label: "주말" },
                { code: "HOLIDAY", label: "공휴일" },
            ],
            unitList: [],
        };
    },
    computed: {
        startDateDisplay() {
            if (this.form.applyStartDt) {
                const date = new Date(this.form.applyStartDt);
                return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
            }
            return `${this.startDateYear}년 ${this.startDateMonth}월 ${this.startDateDay}일`;
        },
        endDateDisplay() {
            if (this.form.applyEndDt) {
                const date = new Date(this.form.applyEndDt);
                return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
            }
            return "미지정";
        },
        startDateDays() {
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        endDateDays() {
            if (!this.endDateMonth) return [];
            const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        allSelected() {
            return this.filteredCosts.length > 0 && this.selectedCosts.length === this.filteredCosts.length;
        },

        filteredCosts() {
            let filtered = [...this.costs];

            // 공급자 필터링
            if (this.filterSupplier) {
                filtered = filtered.filter((c) => c.supplierIdx == this.filterSupplier);
            }

            // 타입 필터링
            if (this.filterType) {
                // 누진제는 사용량 단가 구조(hasProgressive)로도 표시된다
                filtered = filtered.filter((c) =>
                    this.filterType === "Progressive"
                        ? c.baseFeeCalcType === "Progressive" || Number(c.hasProgressive) === 1
                        : c.baseFeeCalcType === this.filterType,
                );
            }

            // 검색어 필터링
            if (this.searchKeyword.trim()) {
                const searchLower = this.searchKeyword.toLowerCase();
                filtered = filtered.filter((c) => c.costName.toLowerCase().includes(searchLower));
            }

            return filtered;
        },
        formTitle() {
            if (this.isViewMode) {
                return "요금제 상세";
            } else if (this.isEditMode) {
                return "요금제 설정";
            } else {
                return "요금제 등록";
            }
        },
        costStructureType() {
            const p = this.form.hasProgressive;
            const s = this.form.hasSeason;
            const t = this.form.hasTimeSlot;
            const d = this.form.hasDayType;
            const pc = this.form.hasFlatCost;
            const count = s + t + d + pc;

            if (p === 1) {
                return {
                    level: "progressive",
                    name: "누진제",
                    description: "사용량 구간별로 단위요금이 달라집니다",
                    dimensions: ["usageRange"],
                };
            }

            if (pc === 1) {
                return {
                    level: "platCost",
                    name: "단일 요금제",
                    description: "단일 요금제로 단위요금이 고정됩니다.",
                    dimensions: [],
                    value: this.form.flatCostFee ? this.form.flatCostFee : 0,
                };
            }

            if (count === 0) {
                return null; // 아무것도 선택 안함
            }

            if (count === 1) {
                const dims = [];
                const name = [];
                if (s) {
                    dims.push("season");
                    name.push("계절");
                }
                if (t) {
                    dims.push("timeSlot");
                    name.push("시간대");
                }
                if (d) {
                    dims.push("dayType");
                    name.push("요일");
                }

                return {
                    level: "single",
                    name: `${name[0]}별`,
                    description: `${name[0]}별로 단위요금이 달라집니다.`,
                    dimensions: dims,
                };
            }

            if (count === 2) {
                const dims = [];
                const name = [];
                if (s) {
                    dims.push("season");
                    name.push("계절");
                }
                if (t) {
                    dims.push("timeSlot");
                    name.push("시간대");
                }
                if (d) {
                    dims.push("dayType");
                    name.push("요일");
                }

                return {
                    level: "dual",
                    name: `${name[0]} × ${name[1]}`,
                    description: `${name[0]}과 ${name[1]} 조합에 따라 단위요금이 달라집니다.`,
                    dimensions: dims,
                };
            }

            if (count === 3) {
                return {
                    level: "triple",
                    name: "계절 × 시간대 × 요일",
                    description: "계절, 시간대, 요일의 모든 조합에 따라 단위요금이 달라집니다.",
                    dimensions: ["season", "timeSlot", "dayType"],
                };
            }

            return null;
        },
        // 상세보기용 단위요금 구조 타입
        viewStructureType() {
            if (!this.costDetail) return "none";
            if (this.costDetail.hasProgressive === 1) return "progressive";

            const dimensionCount =
                (this.costDetail.hasSeason || 0) +
                (this.costDetail.hasTimeSlot || 0) +
                (this.costDetail.hasDayType || 0);

            if (dimensionCount === 1) return "single";
            if (dimensionCount === 2) return "dual";
            if (dimensionCount === 3) return "triple";
            return "none";
        },
        // 1차원 타입 판별
        singleDimensionType() {
            if (!this.costDetail) return null;
            if (this.costDetail.hasSeason) return "season";
            if (this.costDetail.hasTimeSlot) return "timeSlot";
            if (this.costDetail.hasDayType) return "dayType";
            return null;
        },
        // 2차원 조합 판별
        dualDimensionTypes() {
            if (!this.costDetail) return [];
            const types = [];
            if (this.costDetail.hasSeason) types.push("season");
            if (this.costDetail.hasTimeSlot) types.push("timeSlot");
            if (this.costDetail.hasDayType) types.push("dayType");
            return types;
        },
        // 필드 표시 여부 (유틸리티 함수 기반)
        shouldShowBaseFeeValue() {
            return shouldShowField("baseFeeValue", this.getContext());
        },
        shouldShowFlatCostFee() {
            return shouldShowField("flatCostFee", this.getContext());
        },
        // 필드 필수 여부
        isBaseFeeValueRequired() {
            return isFieldRequired("baseFeeValue", this.getContext());
        },
        isFlatCostFeeRequired() {
            return isFieldRequired("flatCostFee", this.getContext());
        },
    },
    watch: {},
    mounted() {
        this.loadData();
        this.loadSuppliers();
        this.loadUnitList();
    },
    methods: {
        /**
         * 필드 표시 규칙을 위한 컨텍스트 생성
         * @returns {object} 컨텍스트 객체
         */
        getContext() {
            const selectedSupplier = this.supplierList.find((s) => s.supplierIdx === this.form.supplierIdx);
            return {
                baseFeeCalcType: this.form.baseFeeCalcType,
                hasFlatCost: this.form.hasFlatCost,
                hasProgressive: this.form.hasProgressive,
                hasSeason: this.form.hasSeason,
                hasTimeSlot: this.form.hasTimeSlot,
                hasDayType: this.form.hasDayType,
                energySourceCode: selectedSupplier?.energySourceCode,
            };
        },
        async loadUnitList() {
            try {
                const result = await backEndApi.newUnitCode.getUnitCodeList();
                if (result.status == 200) {
                    const filtered = result.data.find((unit) => unit.unitCode === "energy");
                    const units = this.$store.state.units;
                    this.unitList = filtered ? filtered.codeItems : units;
                }
            } catch (error) {
                console.error("단위 목록 조회 실패:", error);
                await this.alertWarning("단위 목록을 불러오는데 실패했습니다.");
            }
        },
        async loadData() {
            try {
                const params = {};
                const result = await backEndApi.energyBillCalc.getCostList(params);
                if (result.status == 200) {
                    this.costs = result.data;
                } else {
                    await this.alertWarning(result.data.message);
                }
            } catch (error) {
                console.error("요금제 목록 조회 실패:", error);
                await this.alertWarning("요금제 목록을 불러오는데 실패했습니다.");
            }
        },
        async loadSuppliers() {
            try {
                const params = { enabled: "Y" };
                const result = await backEndApi.energyBillCalc.getSupplierList(params);
                if (result.status == 200) {
                    this.supplierList = result.data;
                }
            } catch (error) {
                console.error("공급자 목록 조회 실패:", error);
            }
        },
        async loadDetailData(costIdx) {
            try {
                const result = await backEndApi.energyBillCalc.getCost(costIdx);
                if (result.status == 200) {
                    this.costDetail = result.data;
                } else {
                    await this.alertWarning(result.data.message);
                }
            } catch (error) {
                console.error("요금제 상세 조회 실패:", error);
                await this.alertWarning("요금제 상세 조회 실패");
            }
        },
        getChargeTypeName(code) {
            const typeMap = {
                Fixed: "고정",
                Contract: "계약기반",
                Demand: "수요기반",
                Progressive: "누진제",
                PeakLinked: "피크연동제",
            };
            return typeMap[code] || code;
        },
        formatNumber(value, decimalPlaces = 0) {
            if (value === null || value === undefined || isNaN(value)) {
                return "-";
            }
            return parseFloat(value).toLocaleString(undefined, {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        },
        formatUsageRange(detail) {
            if (detail.usageFrom !== null && detail.usageFrom !== undefined) {
                if (detail.usageTo !== null && detail.usageTo !== undefined) {
                    return `${detail.usageFrom} ~ ${detail.usageTo} kWh`;
                } else {
                    return `${detail.usageFrom} kWh 이상`;
                }
            }
            return "-";
        },
        formatTimeSlot(detail) {
            if (detail.timeSlotCode) {
                return detail.timeSlotCode;
            }
            if (detail.hourStart !== null && detail.hourEnd !== null) {
                return `${detail.hourStart}시 ~ ${detail.hourEnd}시`;
            }
            return "전체";
        },
        // 계절 라벨 가져오기
        getSeasonLabel(code) {
            const season = this.seasonOptions.find((s) => s.code === code);
            return season ? season.label : code || "-";
        },
        // 시간대 라벨 가져오기
        getTimeSlotLabel(code) {
            const timeSlot = this.timeSlotOptions.find((t) => t.code === code);
            return timeSlot ? timeSlot.label : code || "-";
        },
        // 요일 라벨 가져오기
        getDayTypeLabel(code) {
            const dayType = this.dayTypeOptions.find((d) => d.code === code);
            return dayType ? dayType.label : code || "-";
        },
        // 2차원: 특정 조합의 단위요금 가져오기
        getDetailPrice(seasonCode, timeSlotCode, dayType) {
            const detail = this.viewCostDetails.find((d) => {
                if (seasonCode !== undefined && d.seasonCode !== seasonCode) return false;
                if (timeSlotCode !== undefined && d.timeSlotCode !== timeSlotCode) return false;
                if (dayType !== undefined && d.dayType !== dayType) return false;
                return true;
            });
            return detail ? this.formatNumber(detail.unitPrice, 2) : "-";
        },
        // 3차원: 특정 조합의 단위요금 가져오기
        getTripleDetailPrice(seasonCode, timeSlotCode, dayType) {
            const detail = this.viewCostDetails.find(
                (d) => d.seasonCode === seasonCode && d.timeSlotCode === timeSlotCode && d.dayType === dayType,
            );
            return detail ? this.formatNumber(detail.unitPrice, 2) : "-";
        },
        // 상세보기용 시간대 그리드 메서드
        getViewTimeSlots(seasonCode, dayType) {
            return this.viewCostDetails
                .filter((d) => d.seasonCode === seasonCode && d.dayType === dayType)
                .sort((a, b) => a.hourStart - b.hourStart);
        },
        getViewTimeSlotAtHour(seasonCode, dayType, hour) {
            const slots = this.getViewTimeSlots(seasonCode, dayType);
            // hourEnd는 미포함이므로 < 로 비교해야 함
            return slots.find((slot) => hour >= slot.hourStart && hour < slot.hourEnd);
        },
        isViewTimeSlotStart(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            return slot && slot.hourStart === hour;
        },
        getViewTimeSlotRowspan(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            if (!slot) return 1;
            // hourEnd는 미포함이므로 +1을 하지 않음
            return slot.hourEnd - slot.hourStart;
        },
        getViewTimeSlotEndHour(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            if (!slot) return hour;
            // hourEnd를 그대로 표시 (24인 경우만 23으로 표시)
            return slot.hourEnd === 24 ? 23 : slot.hourEnd;
        },
        getViewLoadTypeName(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            if (!slot) return "-";
            const timeSlotMap = {
                LOW: "경부하",
                MID: "중부하",
                PEAK: "최대부하",
            };
            return timeSlotMap[slot.timeSlotCode] || slot.timeSlotCode;
        },
        getViewTimeSlotPrice(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            return slot ? this.formatNumber(slot.unitPrice, 2) : "-";
        },
        getViewLoadTypeClass(seasonCode, dayType, hour) {
            const slot = this.getViewTimeSlotAtHour(seasonCode, dayType, hour);
            if (!slot) return "";
            const classMap = {
                LOW: "load-low",
                MID: "load-mid",
                PEAK: "load-peak",
            };
            return classMap[slot.timeSlotCode] || "";
        },
        handleSearch() {
            // computed에서 자동 처리됨
        },
        resetSearch() {
            this.searchKeyword = "";
            this.filterSupplier = "";
            this.filterType = "";
        },

        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedCosts = [];
            } else {
                this.selectedCosts = this.filteredCosts.map((cost) => cost.costIdx);
            }
        },

        async handleExport() {
            if (this.selectedCosts.length === 0) {
                await this.alertWarning("내보낼 요금제를 선택해주세요.");
                return;
            }

            try {
                const result = await backEndApi.energyBillCalc.exportCosts(this.selectedCosts);

                if (result.status === 200 && result.data) {
                    const exportData = result.data;
                    const jsonStr = JSON.stringify(exportData, null, 2);
                    const blob = new Blob([jsonStr], { type: "application/json" });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;

                    const today = new Date();
                    const dateStr = today.toISOString().split("T")[0].replace(/-/g, "");
                    link.download = `요금제_Export_${dateStr}.json`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);

                    await this.alertNoti(`${this.selectedCosts.length}개의 요금제가 Export되었습니다.`);
                    this.selectedCosts = [];
                } else {
                    await this.alertWarning("Export에 실패했습니다.");
                }
            } catch (error) {
                console.error("Export 실패:", error);
                await this.alertWarning(error.response?.data?.message || "Export 중 오류가 발생했습니다.");
            }
        },

        handleImport() {
            // 파일 input 생성 및 클릭
            if (!this.importFileInput) {
                const input = document.createElement("input");
                input.type = "file";
                input.accept = ".json";
                input.style.display = "none";
                input.addEventListener("change", (event) => this.handleImportFile(event));
                document.body.appendChild(input);
                this.importFileInput = input;
            }
            this.importFileInput.click();
        },

        async handleImportFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            // 파일 초기화 (같은 파일 다시 선택 가능하도록)
            event.target.value = "";

            try {
                const text = await file.text();
                const importData = JSON.parse(text);

                // Import 데이터 검증
                if (!importData.costs || !Array.isArray(importData.costs)) {
                    await this.alertWarning("잘못된 파일 형식입니다. (costs 배열이 필요합니다)");
                    return;
                }

                // 확인 다이얼로그
                const confirmResult = await this.alertConfirmWarning(
                    `총 ${importData.costs.length}개의 요금제를 Import하시겠습니까?`,
                    "기존 요금제는 업데이트됩니다.",
                );
                if (!confirmResult.value) {
                    return;
                }

                const result = await backEndApi.energyBillCalc.importCosts(importData, true);

                // axios 성공 응답: { status: 200, data: {...}, headers: {...}, ... }
                // 백엔드 성공 응답: { suppliers: {...}, costs: {...} }
                console.log("Import API 응답:", result);

                if (result && result.status === 200) {
                    // result.data가 존재하거나, result 자체가 데이터인 경우 처리
                    const responseData = result.data || result;

                    // suppliers와 costs 필드가 있는지 확인
                    if (responseData && (responseData.suppliers || responseData.costs)) {
                        this.importResult = responseData;
                        this.showImportResult = true;

                        // 목록 새로고침
                        await this.loadData();
                        await this.loadSuppliers();
                    } else {
                        // 응답은 받았지만 예상한 구조가 아닌 경우
                        console.warn("Import 응답 구조가 예상과 다릅니다:", responseData);
                        await this.alertWarning("Import 응답을 처리할 수 없습니다.");
                    }
                } else {
                    console.error("Import 실패 - 응답 상태:", result?.status, "응답 데이터:", result);
                    await this.alertWarning("Import에 실패했습니다.");
                }
            } catch (error) {
                console.error("Import 실패:", error);
                if (error instanceof SyntaxError) {
                    await this.alertWarning("JSON 파일 파싱에 실패했습니다. 파일 형식을 확인해주세요.");
                } else {
                    await this.alertWarning(error.response?.data?.message || "Import 중 오류가 발생했습니다.");
                }
            }
        },

        closeImportResult() {
            this.showImportResult = false;
            this.importResult = null;
        },

        // Alert 헬퍼 메서드 (전역 플러그인 사용)
        async alertWarning(message) {
            return await this.$swal({
                html: message,
                type: "warning",
                showCancelButton: false,
                buttonsStyling: false,
                confirmButtonText: "확인",
                confirmButtonClass: "btn m-r-5 btn-warning",
                keydownListenerCapture: true,
            });
        },
        async alertNoti(message) {
            return await this.$swal({
                html: message,
                type: "success",
                showCancelButton: false,
                buttonsStyling: false,
                confirmButtonText: "확인",
                confirmButtonClass: "btn m-r-5 btn-success",
                timer: 2000,
                keydownListenerCapture: true,
            });
        },
        async alertConfirmWarning(title, text) {
            // title만 전달된 경우 (text가 없거나 undefined인 경우)
            // 또는 text만 전달된 경우 (title이 없거나 undefined인 경우)
            let message;
            if (title && text) {
                message = `${title}<br />${text}`;
            } else {
                message = title || text || "";
            }
            return await this.$swal({
                html: message,
                type: "warning",
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: "확인",
                cancelButtonText: "취소",
                confirmButtonClass: "btn m-r-5 btn-warning",
                cancelButtonClass: "btn btn-default",
                keydownListenerCapture: true,
            });
        },

        exportToExcel() {
            try {
                const excelData = this.filteredCosts.map((cost, index) => ({
                    순번: index + 1,
                    요금표명: cost.costName,
                    공급자: cost.supplier ? cost.supplier.supplierName : "-",
                    타입: this.getChargeTypeName(cost.baseFeeCalcType),
                    기본요금: cost.baseFeeValue,
                    적용시작일: cost.applyStartDt || "-",
                    적용종료일: cost.applyEndDt || "-",
                }));

                const worksheet = XLSX.utils.json_to_sheet(excelData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "요금제 목록");

                const columnWidths = [
                    { wch: 8 }, // 순번
                    { wch: 35 }, // 요금표명
                    { wch: 20 }, // 공급자
                    { wch: 12 }, // 타입
                    { wch: 15 }, // 기본요금
                    { wch: 15 }, // 적용시작일
                    { wch: 15 }, // 적용종료일
                ];
                worksheet["!cols"] = columnWidths;

                const today = new Date();
                const dateStr = today.toISOString().split("T")[0].replace(/-/g, "");
                const fileName = `요금표목록_${dateStr}.xlsx`;

                XLSX.writeFile(workbook, fileName);

                this.$notify({
                    type: "success",
                    title: "성공",
                    text: "엑셀 파일이 다운로드되었습니다.",
                });
            } catch (error) {
                console.error("엑셀 다운로드 실패:", error);
                this.$notify({
                    type: "error",
                    title: "오류",
                    text: "엑셀 파일 다운로드에 실패했습니다.",
                });
            }
        },
        openCreateForm() {
            this.isViewMode = false;
            this.isEditMode = false;
            this.editingCost = null;
            this.resetForm();
            this.showForm = true;
        },
        async openViewForm(cost) {
            this.isViewMode = true;
            this.isEditMode = false;
            this.editingCost = cost;

            await this.loadDetailData(cost.costIdx);

            if (this.costDetail) {
                // 단위요금 정보 저장 (상세보기용)
                this.viewCostDetails = (this.costDetail.details || []).map((detail) => ({
                    detailIdx: detail.detailIdx,
                    usageFrom: detail.usageFrom,
                    usageTo: detail.usageTo,
                    unitPrice: parseFloat(detail.unitPrice) || 0,
                    baseFeeValue: parseFloat(detail.baseFeeValue) || 0,
                    hourStart: detail.hourStart,
                    hourEnd: detail.hourEnd,
                    seasonCode: detail.seasonCode,
                    timeSlotCode: detail.timeSlotCode,
                    dayType: detail.dayType,
                }));

                this.form = {
                    billingUnit: this.costDetail.billingUnit,
                    costIdx: this.costDetail.costIdx,
                    costName: this.costDetail.costName,
                    supplierIdx: this.costDetail.supplierIdx,
                    applyStartDt: this.costDetail.applyStartDt || null,
                    applyEndDt: this.costDetail.applyEndDt || null,
                    baseFeeCalcType: this.costDetail.baseFeeCalcType,
                    baseFeeValue: parseFloat(this.costDetail.baseFeeValue) || 0,
                    flatCostFee: parseFloat(this.costDetail.flatCostFee) || 0,
                    hasFlatCost: this.costDetail.hasFlatCost || 0,
                    hasProgressive: this.costDetail.hasProgressive || 0,
                    hasSeason: this.costDetail.hasSeason || 0,
                    hasTimeSlot: this.costDetail.hasTimeSlot || 0,
                    hasDayType: this.costDetail.hasDayType || 0,
                    vatRate: parseFloat(this.costDetail.vatRate) || 0.1,
                    fuelAdjQuarter: this.costDetail.fuelAdjQuarter || null,
                    enabled: this.costDetail.enabled || "Y",
                    remarks: this.costDetail.remarks || null,
                };

                // 날짜 선택기 상태 설정
                if (this.form.applyStartDt) {
                    const startDate = new Date(this.form.applyStartDt);
                    this.startDateYear = startDate.getFullYear();
                    this.startDateMonth = startDate.getMonth() + 1;
                    this.startDateDay = startDate.getDate();
                }
                if (this.form.applyEndDt) {
                    const endDate = new Date(this.form.applyEndDt);
                    this.endDateYear = endDate.getFullYear();
                    this.endDateMonth = endDate.getMonth() + 1;
                    this.endDateDay = endDate.getDate();
                }
            }

            this.showForm = true;
        },
        async openEditForm(cost) {
            this.isViewMode = false;
            this.isEditMode = true;
            this.editingCost = cost;

            // 상세 데이터 로드
            await this.loadDetailData(cost.costIdx);

            if (this.costDetail) {
                this.form = {
                    billingUnit: this.costDetail.billingUnit,
                    costIdx: this.costDetail.costIdx,
                    costName: this.costDetail.costName,
                    supplierIdx: this.costDetail.supplierIdx,
                    applyStartDt: this.costDetail.applyStartDt || null,
                    applyEndDt: this.costDetail.applyEndDt || null,
                    baseFeeCalcType: this.costDetail.baseFeeCalcType,
                    baseFeeValue: parseFloat(this.costDetail.baseFeeValue) || 0,
                    flatCostFee: parseFloat(this.costDetail.flatCostFee) || 0,
                    hasFlatCost: this.costDetail.hasFlatCost || 0,
                    hasProgressive: this.costDetail.hasProgressive || 0,
                    hasSeason: this.costDetail.hasSeason || 0,
                    hasTimeSlot: this.costDetail.hasTimeSlot || 0,
                    hasDayType: this.costDetail.hasDayType || 0,
                    vatRate: parseFloat(this.costDetail.vatRate) || 0.1,
                    fuelAdjQuarter: this.costDetail.fuelAdjQuarter || null,
                    enabled: this.costDetail.enabled || "Y",
                    remarks: this.costDetail.remarks || null,
                };

                // 수정 전 단위요금 구조 저장 (변경 감지용)
                this.originalStructure = {
                    hasProgressive: this.costDetail.hasProgressive || 0,
                    hasSeason: this.costDetail.hasSeason || 0,
                    hasTimeSlot: this.costDetail.hasTimeSlot || 0,
                    hasDayType: this.costDetail.hasDayType || 0,
                    hasFlatCost: this.costDetail.hasFlatCost || 0,
                };

                // 날짜 선택기 상태 설정
                if (this.form.applyStartDt) {
                    const startDate = new Date(this.form.applyStartDt);
                    this.startDateYear = startDate.getFullYear();
                    this.startDateMonth = startDate.getMonth() + 1;
                    this.startDateDay = startDate.getDate();
                }
                if (this.form.applyEndDt) {
                    const endDate = new Date(this.form.applyEndDt);
                    this.endDateYear = endDate.getFullYear();
                    this.endDateMonth = endDate.getMonth() + 1;
                    this.endDateDay = endDate.getDate();
                }
            }

            this.showForm = true;
        },
        closeForm() {
            this.showForm = false;
            this.isViewMode = false;
            this.isEditMode = false;
            this.editingCost = null;
            this.costDetail = null;
            this.viewCostDetails = [];
            this.originalStructure = null;
            this.resetForm();
        },
        resetForm() {
            this.form = {
                billingUnit: null,
                costName: null,
                supplierIdx: null,
                applyStartDt: null,
                applyEndDt: null,
                baseFeeCalcType: null,
                baseFeeValue: 0,
                hasProgressive: 0,
                flatCostFee: 0,
                hasFlatCost: 0,
                hasSeason: 0,
                hasTimeSlot: 0,
                hasDayType: 0,
                vatRate: 0.1,
                fuelAdjQuarter: null,
                enabled: "Y",
                remarks: null,
            };
            // 날짜 선택기 초기화 (오늘 날짜로 적용시작일도 함께 설정)
            const today = new Date();
            this.startDateYear = today.getFullYear();
            this.startDateMonth = today.getMonth() + 1;
            this.startDateDay = today.getDate();
            // 종료일은 초기화하지 않음 (null로 유지)
            this.endDateYear = today.getFullYear();
            this.endDateMonth = null;
            this.endDateDay = null;
            this.showStartDatePicker = false;
            this.showEndDatePicker = false;
            // 적용시작일을 오늘로 설정해 두어, 클릭 없이 저장해도 누락되지 않도록 함
            this.updateStartDate();
        },
        // 시작일 날짜 선택기 메서드
        toggleStartDatePicker() {
            if (this.isViewMode) return;
            this.showStartDatePicker = !this.showStartDatePicker;
            if (this.showStartDatePicker && this.form.applyStartDt) {
                const date = new Date(this.form.applyStartDt);
                this.startDateYear = date.getFullYear();
                this.startDateMonth = date.getMonth() + 1;
                this.startDateDay = date.getDate();
            }
        },
        closeStartDatePicker() {
            this.showStartDatePicker = false;
        },
        changeStartYear(direction) {
            if (this.isViewMode) return;
            this.startDateYear += direction;
            // 년이 변경되면 일을 해당 월의 마지막 날로 조정 (윤년 고려)
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            if (this.startDateDay > daysInMonth) {
                this.startDateDay = daysInMonth;
            }
            this.updateStartDate();
        },
        selectStartMonth(month) {
            if (this.isViewMode) return;
            this.startDateMonth = month;
            // 월이 변경되면 일을 해당 월의 마지막 날로 조정
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            if (this.startDateDay > daysInMonth) {
                this.startDateDay = daysInMonth;
            }
            this.updateStartDate();
        },
        selectStartDay(day) {
            if (this.isViewMode) return;
            this.startDateDay = day;
            this.showStartDatePicker = false;
            this.updateStartDate();
        },
        updateStartDate() {
            const year = String(this.startDateYear);
            const month = String(this.startDateMonth).padStart(2, "0");
            const day = String(this.startDateDay).padStart(2, "0");
            this.form.applyStartDt = `${year}-${month}-${day}`;
        },
        // 종료일 날짜 선택기 메서드
        toggleEndDatePicker() {
            if (this.isViewMode) return;
            this.showEndDatePicker = !this.showEndDatePicker;
            if (this.showEndDatePicker) {
                if (this.form.applyEndDt) {
                    const date = new Date(this.form.applyEndDt);
                    this.endDateYear = date.getFullYear();
                    this.endDateMonth = date.getMonth() + 1;
                    this.endDateDay = date.getDate();
                } else {
                    // 종료일이 null일 때는 기본값 설정 (선택 전까지는 null 유지)
                    const today = new Date();
                    this.endDateYear = today.getFullYear();
                    this.endDateMonth = today.getMonth() + 1;
                    this.endDateDay = today.getDate();
                }
            }
        },
        closeEndDatePicker() {
            this.showEndDatePicker = false;
        },
        changeEndYear(direction) {
            if (this.isViewMode) return;
            this.endDateYear += direction;
            // 년이 변경되면 일을 해당 월의 마지막 날로 조정 (윤년 고려)
            if (this.endDateMonth) {
                const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
                if (this.endDateDay && this.endDateDay > daysInMonth) {
                    this.endDateDay = daysInMonth;
                }
                this.updateEndDate();
            }
        },
        selectEndMonth(month) {
            if (this.isViewMode) return;
            this.endDateMonth = month;
            // 월이 변경되면 일을 해당 월의 마지막 날로 조정
            if (this.endDateDay) {
                const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
                if (this.endDateDay > daysInMonth) {
                    this.endDateDay = daysInMonth;
                }
            } else {
                // 일이 선택되지 않았으면 1일로 설정
                this.endDateDay = 1;
            }
            this.updateEndDate();
        },
        selectEndDay(day) {
            if (this.isViewMode) return;
            this.endDateDay = day;
            this.showEndDatePicker = false;
            this.updateEndDate();
        },
        updateEndDate() {
            // 월과 일이 모두 선택되었을 때만 날짜 설정
            if (this.endDateMonth && this.endDateDay) {
                const year = String(this.endDateYear);
                const month = String(this.endDateMonth).padStart(2, "0");
                const day = String(this.endDateDay).padStart(2, "0");
                this.form.applyEndDt = `${year}-${month}-${day}`;
            } else {
                // 월이나 일이 선택되지 않았으면 null 유지
                this.form.applyEndDt = null;
            }
        },
        clearEndDate() {
            if (this.isViewMode) return;
            // 종료일을 null로 초기화
            this.form.applyEndDt = null;
            // 날짜 선택기 변수들도 초기화
            const today = new Date();
            this.endDateYear = today.getFullYear();
            this.endDateMonth = null;
            this.endDateDay = null;
            // 드롭다운 닫기
            this.showEndDatePicker = false;
        },
        async handleDelete(cost) {
            const confirm = await this.alertConfirmWarning(`'${cost.costName}' 요금표를 삭제하시겠습니까?`);
            if (confirm.value) {
                try {
                    const result = await backEndApi.energyBillCalc.deleteCost(cost.costIdx);
                    if (result.status == 200) {
                        await this.alertNoti("삭제되었습니다.");
                        this.closeForm();
                        this.loadData();
                    } else {
                        await this.alertWarning(result.data.message);
                    }
                } catch (error) {
                    console.error("요금제 삭제 실패:", error);
                    await this.alertWarning("요금제 삭제 실패");
                }
            }
        },
        async handleDeleteSelected() {
            if (this.selectedCosts.length === 0) {
                await this.alertWarning("삭제할 요금제를 선택해주세요.");
                return;
            }

            // 삭제할 요금제 이름 가져오기 (확인 다이얼로그용)
            const selectedCostNames = this.costs
                .filter((cost) => this.selectedCosts.includes(cost.costIdx))
                .map((cost) => cost.costName);

            // 확인 다이얼로그
            const confirmMessage =
                selectedCostNames.length <= 3
                    ? `다음 요금제를 삭제하시겠습니까?<br /><br />${selectedCostNames.map((name) => `• ${name}`).join("<br />")}`
                    : `총 ${this.selectedCosts.length}개의 요금제를 삭제하시겠습니까?`;
            const confirm = await this.alertConfirmWarning(confirmMessage, "이 작업은 되돌릴 수 없습니다.");
            if (!confirm.value) {
                return;
            }

            // 순차 삭제 실행
            const results = {
                success: [],
                failed: [],
            };

            for (const costIdx of this.selectedCosts) {
                try {
                    const result = await backEndApi.energyBillCalc.deleteCost(costIdx);
                    if (result.status === 200) {
                        const cost = this.costs.find((c) => c.costIdx === costIdx);
                        results.success.push(cost ? cost.costName : `ID: ${costIdx}`);
                    } else {
                        const cost = this.costs.find((c) => c.costIdx === costIdx);
                        results.failed.push({
                            name: cost ? cost.costName : `ID: ${costIdx}`,
                            reason: result.data?.message || "삭제 실패",
                        });
                    }
                } catch (error) {
                    console.error(`요금제 삭제 실패 (costIdx: ${costIdx}):`, error);
                    const cost = this.costs.find((c) => c.costIdx === costIdx);
                    results.failed.push({
                        name: cost ? cost.costName : `ID: ${costIdx}`,
                        reason: error.response?.data?.message || "삭제 중 오류 발생",
                    });
                }
            }

            // 결과 알림
            if (results.failed.length === 0) {
                // 전체 성공
                await this.alertNoti(`${results.success.length}개의 요금제가 삭제되었습니다.`);
            } else if (results.success.length === 0) {
                // 전체 실패
                const failedList = results.failed.map((f) => `• ${f.name}: ${f.reason}`).join("<br />");
                await this.alertWarning(`모든 요금제 삭제에 실패했습니다.<br /><br />${failedList}`);
            } else {
                // 부분 성공
                const failedList = results.failed.map((f) => `• ${f.name}: ${f.reason}`).join("<br />");
                await this.alertWarning(
                    `${results.success.length}개 성공, ${results.failed.length}개 실패했습니다.<br /><br />실패한 항목:<br />${failedList}`,
                );
            }

            // 선택 초기화 및 목록 새로고침
            this.selectedCosts = [];
            this.closeForm();
            await this.loadData();
        },
        handleProgressiveChange() {
            // 누진제가 선택된 경우
            if (this.form.hasProgressive === 1) {
                // 단일 요금제와 나머지 3개를 강제로 해제
                this.form.hasFlatCost = 0;
                this.form.hasSeason = 0;
                this.form.hasTimeSlot = 0;
                this.form.hasDayType = 0;
            }
            // 누진제가 해제된 경우는 아무것도 하지 않음 (다른 옵션들이 다시 선택 가능해짐)
        },
        handlePlatCostChange() {
            // 단일 요금제가 선택된 경우
            if (this.form.hasFlatCost === 1) {
                // 누진제와 나머지 3개를 강제로 해제
                this.form.hasProgressive = 0;
                this.form.hasSeason = 0;
                this.form.hasTimeSlot = 0;
                this.form.hasDayType = 0;
            }
            // 단일 요금제가 해제된 경우는 아무것도 하지 않음 (다른 옵션들이 다시 선택 가능해짐)
        },
        async handleSave() {
            // 필수 입력 검증 (디버깅 정보 포함)
            const missingFields = [];
            if (!this.form.costName || this.form.costName.trim() === "") {
                missingFields.push("요금표명");
            }
            if (!this.form.supplierIdx) {
                missingFields.push("공급자");
            }
            if (!this.form.baseFeeCalcType) {
                missingFields.push("기본요금 계산 방식");
            }
            if (!this.form.applyStartDt) {
                missingFields.push("적용 시작일");
            }

            if (missingFields.length > 0) {
                await this.alertWarning(`필수 항목을 모두 입력해주세요.<br />누락된 항목: ${missingFields.join(", ")}`);
                return;
            }

            // 기본요금 계산 방식별 baseFeeValue 검증
            if (
                this.form.baseFeeCalcType &&
                ["Fixed", "Contract", "Demand", "PeakLinked"].includes(this.form.baseFeeCalcType) &&
                (!this.form.baseFeeValue || this.form.baseFeeValue === 0)
            ) {
                await this.alertWarning(
                    `${this.getChargeTypeName(this.form.baseFeeCalcType)} 방식은 기본요금 값이 필요합니다.`,
                );
                return;
            }

            // flatCostFee 검증 (hasFlatCost === 1일 때 필수)
            if (this.form.hasFlatCost === 1) {
                if (!this.form.flatCostFee || this.form.flatCostFee <= 0) {
                    await this.alertWarning("단일 요금제 단위요금(flatCostFee)은 필수입니다.");
                    return;
                }
            }

            // 단위요금 구조 검증 (최소 1개 선택)
            if (
                this.form.hasProgressive === 0 &&
                this.form.hasSeason === 0 &&
                this.form.hasTimeSlot === 0 &&
                this.form.hasDayType === 0 &&
                this.form.hasFlatCost === 0
            ) {
                await this.alertWarning("단위요금 구조를 최소 1개 이상 선택해주세요.");
                return;
            }

            try {
                // 단위요금 구조 변경 여부 확인 (수정 모드일 때만)
                let structureChanged = false;
                if (this.isEditMode && this.originalStructure) {
                    structureChanged =
                        this.originalStructure.hasProgressive !== this.form.hasProgressive ||
                        this.originalStructure.hasSeason !== this.form.hasSeason ||
                        this.originalStructure.hasTimeSlot !== this.form.hasTimeSlot ||
                        this.originalStructure.hasDayType !== this.form.hasDayType ||
                        this.originalStructure.hasFlatCost !== this.form.hasFlatCost;
                }

                const payload = {
                    billingUnit: this.form.billingUnit,
                    costName: this.form.costName,
                    supplierIdx: this.form.supplierIdx,
                    applyStartDt: this.form.applyStartDt,
                    applyEndDt: this.form.applyEndDt,
                    baseFeeCalcType: this.form.baseFeeCalcType,
                    baseFeeValue: this.form.baseFeeValue,
                    flatCostFee: this.form.flatCostFee,
                    hasFlatCost: this.form.hasFlatCost,
                    hasProgressive: this.form.hasProgressive,
                    hasSeason: this.form.hasSeason,
                    hasTimeSlot: this.form.hasTimeSlot,
                    hasDayType: this.form.hasDayType,
                    vatRate: this.form.vatRate,
                    fuelAdjQuarter: this.form.fuelAdjQuarter,
                    enabled: this.form.enabled,
                    remarks: this.form.remarks,
                };

                // 수정 모드이고 단위요금 구조가 변경된 경우, details를 빈 배열로 추가
                if (this.isEditMode && structureChanged) {
                    payload.details = [];
                }

                let result;
                if (this.isEditMode) {
                    const confirm = await this.alertConfirmWarning("요금제 정보를 수정하시겠습니까?");
                    if (!confirm.value) return;
                    payload.costIdx = this.editingCost.costIdx;
                    result = await backEndApi.energyBillCalc.updateCost(payload);
                } else {
                    const confirm = await this.alertConfirmWarning("새로운 요금표를 등록하시겠습니까?");
                    if (!confirm.value) return;
                    result = await backEndApi.energyBillCalc.insertCost(payload);
                }

                if (result.status === 200) {
                    if (this.isEditMode) {
                        await this.alertNoti("요금제 정보가 수정되었습니다.");
                    } else {
                        // 신규 등록 시 안내 메시지
                        await this.alertNoti(
                            `요금표가 등록되었습니다.<br />단위요금 정보는 목록의 <strong style="color: var(--ebc-primary);">[단위요금 설정]</strong> 버튼을 통해 등록해주세요.`,
                        );
                    }
                    this.closeForm();
                    this.loadData();
                } else {
                    await this.alertWarning(result.data.message || "저장에 실패했습니다.");
                }
            } catch (error) {
                console.error("요금제 저장 실패:", error);
                await this.alertWarning("요금제 정보를 저장하는데 실패했습니다.");
            }
        },
        async openDetailManagement(cost) {
            try {
                // 상세 정보 조회 (has 필드 포함)
                const result = await backEndApi.energyBillCalc.getCost(cost.costIdx);
                if (result.status === 200) {
                    const detail = result.data;
                    this.selectedCostIdx = detail.costIdx;
                    this.selectedCostInfo = {
                        costName: detail.costName,
                        supplierName: detail.supplier ? detail.supplier.supplierName : "-",
                        baseFeeCalcType: detail.baseFeeCalcType,
                        baseFeeValue: detail.baseFeeValue,
                        hasProgressive: detail.hasProgressive || 0,
                        hasSeason: detail.hasSeason || 0,
                        hasTimeSlot: detail.hasTimeSlot || 0,
                        hasDayType: detail.hasDayType || 0,
                        hasFlatCost: detail.hasFlatCost || 0,
                        billingUnit: detail.billingUnit,
                    };
                    // 전체 데이터 저장 (자식 컴포넌트에서 API 중복 호출 방지)
                    this.selectedCostData = detail;
                    this.showDetailManagement = true;
                } else {
                    await this.alertWarning(result.data.message || "요금제 정보를 불러오는데 실패했습니다.");
                }
            } catch (error) {
                console.error("요금제 상세 조회 실패:", error);
                await this.alertWarning("요금제 정보를 불러오는데 실패했습니다.");
            }
        },
        closeDetailManagement() {
            this.showDetailManagement = false;
            this.selectedCostIdx = null;
            this.selectedCostInfo = {};
            this.selectedCostData = null;
        },
        handleDetailSaved() {
            // 단위요금 저장 후 목록 새로고침
            this.loadData();
        },
    },
};
</script>

<style scoped>
.cost-management {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* 헤더 */
.content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--ebc-hairline);
}

.content-header h3 {
    font-size: 15px;
    font-weight: 700;
    color: var(--ebc-text);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.content-header h3 i {
    color: var(--ebc-primary);
}

.header-content-group {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    justify-content: flex-end;
}

.header-actions-group {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.btn-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-action i {
    font-size: 12px;
}

.btn-excel {
    background: white;
    color: var(--ebc-positive);
    border-color: var(--ebc-positive);
}

.btn-excel:hover {
    background: var(--ebc-positive-tint);
}

.btn-action.btn-secondary {
    background: var(--ebc-text-sub);
    color: white;
    border: none;
}

.btn-action.btn-secondary:hover:not(:disabled) {
    background: var(--ebc-text);
}

.btn-action.btn-secondary:disabled {
    background: var(--ebc-border-strong);
    color: var(--ebc-text-muted);
    cursor: not-allowed;
}

.btn-action.btn-danger {
    background: var(--ebc-danger);
    color: white;
    border: none;
}

.btn-action.btn-danger:hover:not(:disabled) {
    background: var(--ebc-danger);
}

.btn-action.btn-danger:disabled {
    background: var(--ebc-border-strong);
    color: var(--ebc-text-muted);
    cursor: not-allowed;
}

.btn-primary {
    background: var(--ebc-primary);
    color: var(--ebc-surface);
    border: 1px solid var(--ebc-primary);
}

.btn-primary:hover {
    background: var(--ebc-primary-hover);
    border-color: var(--ebc-primary-hover);
    color: var(--ebc-surface);
}

/* Import 결과 모달 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.28);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.import-result-modal {
    background: white;
    border-radius: var(--ebc-radius-sm);
    width: 90%;
    max-width: 700px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
    padding: 20px;
    border-bottom: 1px solid var(--ebc-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: var(--ebc-text);
}

.btn-close-modal {
    background: none;
    border: none;
    font-size: 15px;
    color: var(--ebc-text-sub);
    cursor: pointer;
    padding: 4px 8px;
    border-radius: var(--ebc-radius-xs);
}

.btn-close-modal:hover {
    background: var(--ebc-track);
    color: var(--ebc-text);
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.modal-body h5 {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--ebc-text);
}

.modal-body h5:not(:first-child) {
    margin-top: 24px;
}

.import-result-section {
    margin-bottom: 16px;
}

.result-item {
    margin-bottom: 12px;
    padding: 12px;
    border-radius: var(--ebc-radius-xs);
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.result-item.success {
    background: var(--ebc-positive-tint);
    border: 1px solid var(--ebc-positive-tint);
}

.result-item.info {
    background: var(--ebc-primary-tint);
    border: 1px solid var(--ebc-navy-4);
}

.result-item.warning {
    background: var(--ebc-warn-tint);
    border: 1px solid var(--ebc-warn);
}

.result-item.error {
    background: var(--ebc-danger-tint);
    border: 1px solid var(--ebc-danger-tint);
}

.result-item i {
    margin-top: 2px;
    flex-shrink: 0;
}

.result-item.success i {
    color: var(--ebc-positive);
}

.result-item.info i {
    color: var(--ebc-primary-hover);
}

.result-item.warning i {
    color: var(--ebc-warn);
}

.result-item.error i {
    color: var(--ebc-danger);
}

.result-item span {
    font-weight: 600;
    color: var(--ebc-text);
    flex-shrink: 0;
}

.result-item ul {
    margin: 8px 0 0 0;
    padding-left: 20px;
    flex: 1;
}

.result-item li {
    margin-bottom: 4px;
    color: var(--ebc-text-sub);
    font-size: 13px;
}

.modal-footer {
    padding: 16px 20px;
    border-top: 1px solid var(--ebc-border);
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.modal-footer button {
    border: none;
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

/* 헤더 안의 검색 바 */
.search-bar-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.search-bar-header .form-field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
}

.search-bar-header .form-field-inline label {
    font-size: 12px;
    font-weight: 600;
    color: var(--ebc-text);
    white-space: nowrap;
    margin: 0;
}

.search-input-group-header {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input-group-header i {
    position: absolute;
    left: 10px;
    color: var(--ebc-text-muted);
    font-size: 12px;
    z-index: 1;
}

.search-input-header {
    padding: 6px 10px 6px 30px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 12px;
    min-width: 180px;
    height: 32px;
    box-sizing: border-box;
}

.search-input-header:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 2px var(--ebc-primary-tint);
}

.form-select-header {
    padding: 6px 10px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 12px;
    transition: all 0.2s;
    min-width: 120px;
    height: 32px;
    background: var(--ebc-surface);
    cursor: pointer;
}

.form-select-header:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 2px var(--ebc-primary-tint);
}

.btn-search-header {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: none;
    border-radius: var(--ebc-radius-xs);
    background: var(--ebc-primary);
    color: white;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-search-header:hover {
    background: var(--ebc-primary-hover);
}

/* 데이터 테이블 */
.data-table-container {
    flex: 1;
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    overflow-y: auto;
    height: 100%;
}

.settings-data-table {
    width: 100%;
    border-collapse: collapse;
}

.settings-data-table thead {
    background: var(--ebc-surface-sunken);
}

.settings-data-table th {
    padding: 12px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    border-bottom: 1px solid var(--ebc-hairline);
    position: sticky;
    top: 0;
    background: var(--ebc-surface-sunken);
    z-index: 10;
}

.settings-data-table tbody tr {
    border-bottom: 1px solid var(--ebc-track);
    transition: all 0.2s;
}

.settings-data-table tbody tr:hover {
    background: var(--ebc-surface-sunken);
}

.settings-data-table td {
    padding: 14px 16px;
    font-size: 13px;
    color: var(--ebc-text);
}

.name-text {
    font-weight: 600;
    color: var(--ebc-text);
}

/* 뱃지 스타일 제거 - 에너지원 코드와 상태 코드만 뱃지 사용 */

.count-badge-sm {
    display: inline-block;
    padding: 3px 8px;
    background: var(--ebc-track);
    color: var(--ebc-text-sub);
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
}

.btn-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-text);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 4px;
}

.btn-edit:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-text-muted);
}

.btn-edit i {
    font-size: 11px;
}

.btn-detail {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-text);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 4px;
}

.btn-detail:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-text-muted);
}

.btn-detail i {
    font-size: 11px;
}

.btn-delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-danger);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-danger);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-delete:hover {
    background: var(--ebc-danger-tint);
}

.btn-delete i {
    font-size: 11px;
}

.clickable-row {
    cursor: pointer;
}

.clickable-row:hover {
    background: var(--ebc-surface-sunken) !important;
}

.text-center {
    text-align: center !important;
}

.text-right {
    text-align: right !important;
}

/* 슬라이드 패널 */

.section-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--ebc-text);
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--ebc-hairline);
}

.detail-info {
    margin-top: 24px;
    padding: 12px 16px;
    background: var(--ebc-surface-sunken);
    border-radius: var(--ebc-radius-sm);
    border: 1px solid var(--ebc-border);
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
}

.info-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: none;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 11px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    white-space: nowrap;
}

.info-value {
    font-size: 12px;
    color: var(--ebc-text);
    font-weight: 500;
}

/* 단위요금 정보 안내 박스 */
.cost-detail-info {
    margin-top: 24px;
}

.info-box {
    display: flex;
    gap: 12px;
    padding: 16px;
    background: var(--ebc-warn-tint);
    border: 1px solid rgba(249, 115, 22, 0.25);
    border-radius: var(--ebc-radius-sm);
}

.info-box i {
    font-size: 15px;
    color: var(--ebc-warn);
    flex-shrink: 0;
}

.info-text {
    flex: 1;
}

.info-text strong {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: var(--ebc-warn);
    margin-bottom: 4px;
}

.info-text p {
    font-size: 12px;
    color: var(--ebc-warn);
    margin: 0;
    line-height: 1.5;
}

/* 폼 행 - 2개씩 가로 배치 */
.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}

.form-group {
    margin-bottom: 20px;
}

.form-row .form-group {
    margin-bottom: 0;
}

.form-row .form-group--full {
    grid-column: 1 / -1;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: var(--ebc-text);
}

.required {
    color: var(--ebc-danger);
}

.form-input,
.form-select,
.form-textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 13px;
    transition: all 0.2s;
}

.form-textarea {
    resize: none;
    overflow-y: auto;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 3px var(--ebc-primary-tint);
}

.form-input:disabled,
.form-select:disabled,
.form-textarea:disabled {
    background: var(--ebc-track);
    color: var(--ebc-text-sub);
    cursor: not-allowed;
    border-color: var(--ebc-hairline-strong);
}

.input-with-unit {
    display: flex;
    align-items: center;
    gap: 8px;
}

.input-with-unit .form-input {
    flex: 1;
}

.input-with-unit .unit {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--ebc-text-sub);
}

.input-with-unit .unit-desc {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 500;
    color: var(--ebc-text-muted);
}

.help-text {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: var(--ebc-text-muted);
    line-height: 1.4;
}

/* 체크박스 그룹 */
.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* 체크박스 가로 배치 */
.checkbox-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
}

.checkbox-row .checkbox-label {
    flex: 1;
    min-width: 0;
}

.checkbox-label {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 13px;
    color: var(--ebc-text);
    padding: 10px 14px;
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    background-color: var(--ebc-surface);
    transition: all 0.2s ease;
    line-height: 1;
}

.checkbox-label:hover:not(:has(input:disabled)) {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
}

.checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    flex-shrink: 0;
    accent-color: var(--ebc-primary);
    vertical-align: middle;
}

.checkbox-label input[type="checkbox"]:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.checkbox-label:has(input[type="checkbox"]:checked) {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
}

.checkbox-label:has(input[type="checkbox"]:disabled) {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: var(--ebc-surface-sunken);
}

.checkbox-label span {
    user-select: none;
    line-height: 18px;
    display: inline-flex;
    align-items: center;
}

/* 누진제 배타적 선택 스타일 */
.checkbox-label.exclusive {
    border: 1px solid var(--ebc-hairline-strong);
    background: var(--ebc-surface);
}

.checkbox-label.exclusive:hover:not(:has(input:disabled)) {
    border-color: var(--ebc-danger);
    background: var(--ebc-danger-tint);
}

.checkbox-label.exclusive.active {
    border: 2px solid var(--ebc-danger);
    background: var(--ebc-danger-tint);
    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
}

/* 활성화 상태 */
.checkbox-label.active {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
    box-shadow: var(--ebc-shadow-toggle);
}

/* 비활성화 상태 */
.checkbox-label.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: var(--ebc-surface-sunken);
    border-color: var(--ebc-hairline-strong);
}

.checkbox-label.disabled:hover {
    border-color: var(--ebc-hairline-strong);
    background-color: var(--ebc-surface-sunken);
}

/* 구분선 */
.divider-or {
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--ebc-text-muted);
    font-size: 12px;
    font-weight: 600;
    margin: 8px 0;
}

.divider-or::before,
.divider-or::after {
    content: "";
    flex: 1;
    border-bottom: 1px dashed var(--ebc-border-strong);
    margin: 0 12px;
}

/* 구조 안내 정보 */
.structure-info {
    margin-top: 12px;
    padding: 12px 16px;
    background: var(--ebc-surface-sunken);
    border-left: 4px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-sm);
    display: flex;
    align-items: center;
    gap: 12px;
}

.info-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: var(--ebc-radius-xs);
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    flex-shrink: 0;
}

.info-badge.progressive,
.info-badge.single,
.info-badge.dual,
.info-badge.triple {
    background: var(--ebc-track);
    color: var(--ebc-text);
}

.info-desc {
    font-size: 12px;
    color: var(--ebc-text);
    line-height: 1.5;
}

.btn-cancel,
.btn-save {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-cancel {
    background: white;
    color: var(--ebc-text-sub);
}

.btn-cancel:hover {
    background: var(--ebc-track);
}

.btn-save {
    background: var(--ebc-primary);
    color: var(--ebc-surface);
    border: 1px solid var(--ebc-primary);
}

.btn-save:hover {
    background: var(--ebc-primary-hover);
    border-color: var(--ebc-primary-hover);
    color: var(--ebc-surface);
}

/* 단위요금 정보 섹션 */
.cost-detail-section {
    margin-top: 32px;
}

.detail-table-container {
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    overflow-x: auto;
    max-height: 400px;
    overflow-y: auto;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
}

.detail-table thead {
    background: var(--ebc-surface-sunken);
    position: sticky;
    top: 0;
    z-index: 10;
}

.detail-table th {
    padding: 10px 12px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    border-bottom: 1px solid var(--ebc-hairline);
}

.detail-table td {
    padding: 8px 12px;
    font-size: 12px;
    border-bottom: 1px solid var(--ebc-track);
}

.detail-display {
    font-size: 12px;
    color: var(--ebc-text);
    padding: 6px 8px;
}

.empty-detail {
    text-align: center;
    padding: 40px 20px !important;
    color: var(--ebc-text-muted);
}

.empty-detail i {
    font-size: 22px;
    color: var(--ebc-border-strong);
    margin-bottom: 12px;
}

.empty-detail p {
    margin: 8px 0 0 0;
    font-size: 13px;
}

.empty-detail .help-text {
    font-size: 12px;
    color: var(--ebc-text-muted);
    margin-top: 4px;
}

/* 매트릭스 테이블 스타일 */
.matrix-table {
    background: white;
}

.matrix-table .row-header-cell {
    background: var(--ebc-track);
    font-weight: 700;
    color: var(--ebc-text-sub);
}

.matrix-table .row-header {
    background: var(--ebc-surface-sunken);
    font-weight: 600;
    color: var(--ebc-text-sub);
    text-align: left;
}

.matrix-table td {
    text-align: center;
}

.matrix-table td.text-right {
    text-align: right;
}

/* 차원 배지 */
.badge-dimension {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    background: var(--ebc-track);
    border-radius: var(--ebc-radius-xs);
    font-size: 12px;
    font-weight: 600;
    color: var(--ebc-text);
}

/* 3차원 뷰 */
.triple-dimension-view {
    margin-top: 16px;
}

.season-tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    padding: 12px;
    background: var(--ebc-surface-sunken);
    border-radius: var(--ebc-radius-sm);
}

.season-tab {
    flex: 1;
    padding: 10px 16px;
    border: 2px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    background: white;
    font-size: 13px;
    font-weight: 600;
    color: var(--ebc-text-sub);
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.season-tab:hover {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
    color: var(--ebc-primary);
}

.season-tab.active {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
    color: var(--ebc-primary);
    box-shadow: var(--ebc-shadow-toggle);
}

/* 3차원 시간대 그리드 컨테이너 */
.hour-grid-container {
    margin-top: 4px;
}

.day-type-tabs {
    padding: 6px;
    margin-bottom: 8px;
}

.day-type-grid {
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    overflow: hidden;
}

.hour-grid-table {
    width: 100%;
    border-collapse: collapse;
}

.hour-grid-table thead th {
    background: var(--ebc-surface-sunken);
    padding: 10px 12px;
    font-size: 12px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    border-bottom: 1px solid var(--ebc-border);
    text-align: left;
}

.hour-grid-table tbody td {
    padding: 8px 12px;
    font-size: 12px;
    border-bottom: 1px solid var(--ebc-track);
}

.hour-grid-table tbody tr:last-child td {
    border-bottom: none;
}

.hour-cell {
    font-weight: 600;
    color: var(--ebc-text-sub);
    white-space: nowrap;
}

.load-type-cell {
    font-weight: 600;
    text-align: center;
}

.load-low {
    color: var(--ebc-positive);
}

.load-mid {
    color: var(--ebc-warn);
}

.load-peak {
    color: var(--ebc-danger);
}

.price-cell {
    text-align: right;
    font-weight: 600;
    color: var(--ebc-text);
}

/* 추가 스타일 */
.cost-detail-section {
    margin-top: 32px;
}

.detail-actions {
    margin-bottom: 12px;
}

.btn-sm {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
}

.detail-table-container {
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    overflow-x: auto;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
}

.detail-table thead {
    background: var(--ebc-surface-sunken);
}

.detail-table th {
    padding: 10px 12px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    border-bottom: 1px solid var(--ebc-hairline);
}

.detail-table td {
    padding: 8px 12px;
    font-size: 12px;
    border-bottom: 1px solid var(--ebc-track);
}

.detail-input {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-size: 12px;
}

.detail-input:focus {
    outline: none;
    border-color: var(--ebc-primary);
}

.detail-input-sm {
    width: 80px;
    padding: 6px 8px;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-size: 12px;
    text-align: center;
}

.detail-input-sm:focus {
    outline: none;
    border-color: var(--ebc-primary);
}

.range-inputs {
    display: flex;
    align-items: center;
    gap: 6px;
}

.range-inputs span {
    color: var(--ebc-text-sub);
    font-size: 12px;
}

.detail-display {
    font-size: 12px;
    color: var(--ebc-text);
    padding: 6px 8px;
}

.detail-input:disabled {
    background: var(--ebc-track);
    color: var(--ebc-text-sub);
    cursor: not-allowed;
}

.btn-icon-delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-danger);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-danger);
    cursor: pointer;
    transition: all 0.2s;
}

.btn-icon-delete:hover {
    background: var(--ebc-danger-tint);
}

.empty-detail {
    text-align: center;
    color: var(--ebc-text-muted);
    font-size: 12px;
    padding: 20px !important;
}
/* 날짜 선택기 스타일 (Dashboard와 동일) */
.date-picker-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--ebc-surface);
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    padding: 2px;
    z-index: 100;
}

.nav-btn {
    background: transparent;
    border: none;
    padding: 6px 10px;
    cursor: pointer;
    color: var(--ebc-text-sub);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--ebc-radius-xs);
}

.nav-btn:hover:not(:disabled) {
    color: var(--ebc-primary);
    background: var(--ebc-border);
}

.nav-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.nav-btn:focus {
    outline: none;
}

.date-display {
    padding: 6px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    justify-content: center;
    border-radius: var(--ebc-radius-sm);
    transition: all 0.2s ease;
    color: var(--ebc-text);
    font-weight: 600;
    font-size: 13px;
}

.date-display:hover:not(.disabled) {
    background: var(--ebc-track);
}

.date-display.disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.date-display i {
    font-size: 10px;
    transition: transform 0.2s ease;
}

.date-display i.rotate {
    transform: rotate(180deg);
}

.date-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-md);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 101;
    margin-top: 6px;
    padding: 16px;
    min-width: 240px;
}

.year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--ebc-border);
}

.year-selector button {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 4px 8px;
    cursor: pointer;
    color: var(--ebc-text-sub);
    border-radius: var(--ebc-radius-xs);
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;
}

.year-selector button:focus {
    outline: none;
}

.year-selector button:hover {
    background: var(--ebc-primary);
    color: white;
    border-color: var(--ebc-primary);
}

.year-selector span {
    font-size: 14px;
    font-weight: 700;
    color: var(--ebc-text);
}

.month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
}

.month-btn {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 8px 4px;
    cursor: pointer;
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
    color: var(--ebc-text-sub);
    transition: all 0.2s ease;
    text-align: center;
}

.month-btn:hover {
    background: var(--ebc-border);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text);
}

.month-btn.active {
    background: var(--ebc-primary);
    border-color: var(--ebc-primary);
    color: white;
    box-shadow: 0 1px 4px var(--ebc-primary-tint-strong);
}

.day-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--ebc-border);
}

.day-btn {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 6px 4px;
    cursor: pointer;
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
    color: var(--ebc-text-sub);
    transition: all 0.2s ease;
    text-align: center;
}

.day-btn:hover {
    background: var(--ebc-border);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text);
}

.day-btn.active {
    background: var(--ebc-primary);
    border-color: var(--ebc-primary);
    color: white;
    box-shadow: 0 1px 4px var(--ebc-primary-tint-strong);
}

/* 미지정 버튼 스타일 */
.clear-date-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--ebc-border);
    display: flex;
    justify-content: center;
}

.btn-clear-date {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    width: 100%;
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    color: var(--ebc-text-sub);
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-clear-date:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text-sub);
}

.btn-clear-date i {
    font-size: 11px;
}
</style>
